module.exports = __webpack_public_path__ + "img/icon_checked.84fa1e9.svg";